import React from 'react'

const Skill = ({ item }) => {
    return (
        <div className={`p-4 rounded-custom bg-slate-100/50 dark:bg-slate-800/50 `}>
            <img src={item.image.url} alt={item.name} className="h-[50px]" />
        </div>
    )
}

export default Skill